import { render, staticRenderFns } from "./MedicationVetTemplate.vue?vue&type=template&id=4f7a070b&scoped=true"
import script from "./MedicationVetTemplate.vue?vue&type=script&lang=js"
export * from "./MedicationVetTemplate.vue?vue&type=script&lang=js"
import style0 from "./MedicationVetTemplate.vue?vue&type=style&index=0&id=4f7a070b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a070b",
  null
  
)

export default component.exports